


























































































































































































import {computed, defineComponent, onBeforeUnmount, onMounted, Ref, ref, SetupContext} from "@vue/composition-api"
import io from 'socket.io-client'
import Peer from "@/rooms/Peer.vue"
import {env} from "@/environment"
import router from "@/router"
import Feedback from "@/misc/Feedback.vue"
import GameScreen from "@/games/GameScreen.vue"
import Cookie from '@/cookies'
import Avatar from "@/rooms/Avatar.vue"

interface PeerComponentDescriptor {
  peerId: string;
  offer: RTCSessionDescriptionInit | null;
}

export function cWindowOrientation(store: {commit: (x: string, y: string) => void}) {
  const windowOrientation = ref(window.innerHeight < window.innerWidth ? 'landscape' : 'portrait')
  store.commit('changeWindowOrientation', windowOrientation.value)
  window.onresize = () => {
    windowOrientation.value = window.innerHeight < window.innerWidth ? 'landscape' : 'portrait'
    store.commit('changeWindowOrientation', windowOrientation.value)
  }
  return {windowOrientation}
}

function cBackground() {
  const backgrounds = ['default', 'flags', 'map-wood', 'map-paper', 'simple']
  const backgroundIndex = Cookie.background ?
    ref(backgrounds.indexOf(Cookie.background)) :
    ref(Math.floor(Math.random() * backgrounds.length))
  const background = computed(() => backgrounds[backgroundIndex.value])

  // Handles negative numbers
  const mod = (n: number, m: number) => ((n % m) + m) % m

  function backgroundRight() {
    backgroundIndex.value = mod(backgroundIndex.value + 1, backgrounds.length)
    Cookie.background = background.value
  }

  return {background, backgroundRight}
}

export default defineComponent({
  name: 'RoomPage',
  components: {
    Feedback,
    Peer,
    GameScreen,
    Avatar,
  },
  setup(props, {root}: SetupContext) {
    const socket = io.connect(env.backendUrl)
    const room = root.$route.params.id
    root.$store.commit('setRoom', room)
    root.$store.commit('setSocket', socket)
    const peerId: Ref<string | undefined> = ref(undefined)
    const peers: Ref<PeerComponentDescriptor[]> = ref([])
    const connectionState = ref('Connecting to server...')
    const localStream = ref<MediaStream>()
    const showFeedbackModal = ref(false)

    console.log('Start RoomView component')

    socket.on('room joined', (myPeerId: string) => {
      console.log(`You joined the room with ID ${myPeerId}`)
      peerId.value = myPeerId
      root.$store.commit("setPeerId", myPeerId)
      connectionState.value = 'joined'

      if (!Cookie.nick)
        Cookie.nick = prompt('Enter nickname') ?? undefined

      if(Cookie.nick)
        socket.emit('nick : set', Cookie.nick)
    })

    socket.on('offer', async ({offer, fromId}: { offer: RTCSessionDescriptionInit; fromId: string }) => {
      console.log(`Receive offer from peer ${fromId}`)
      peers.value.push({peerId: fromId, offer: offer})
    })

    socket.on('new peer joined', async (newPeerId: string) => {
      console.log(`Event: new peer joined - newPeerId: ${newPeerId}`)
      peers.value.push({peerId: newPeerId, offer: null})
    })

    socket.on('peer disconnected', (peerId: string) => {
      peers.value = peers.value.filter(peer => peer.peerId !== peerId)
    })

    socket.on('request for vote', ({action, on}: { action: string; on: string }) => {
      console.log(`Request to ${action} ${on}`)
    })

    socket.on('kick', (peerIdToKick: string) => {
      console.log(`Kick peer ${peerIdToKick}`)
      if (peerIdToKick === peerId.value) {
        router.push('/', () => {
          alert('You have been kicked out')
        })
      } else {
        peers.value = peers.value.filter(peer => peer.peerId !== peerIdToKick)
      }
    })

    socket.on('nicks', (nicks: Record<string, string>) => {
      root.$store.commit('setNicks', nicks)
    })

    onMounted(async () => {
      try {
        localStream.value = await navigator.mediaDevices.getUserMedia({
          audio: true,
          video: true
        })

        console.log(`Join room ${room}`)
        socket.emit('create or join', room)
      } catch (error) {
        alert(error)
      }
    })

    onBeforeUnmount(() => {
      console.log(`Leave room ${room}`)
      socket.close()
      localStream.value?.getTracks().forEach(track => track.stop())
    })

    const copyLinkToClipboard = async () => {
      const link = window.location.href
      await navigator.clipboard.writeText(link)
    }
    const shareWithWhatsapp = () => {
      const link = window.location.href
      window.open(`https://wa.me/?text=Join me at ${link}`)
    }

    return {
      room,
      peerId,
      connectionState,
      peers,
      localStream,
      socket,
      copyLinkToClipboard,
      shareWithWhatsapp,
      showFeedbackModal,
      ...cBackground(),
      ...cWindowOrientation(root.$store),
    }
  }
})

